"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyCloserInformationsFields = CompanyCloserInformationsFields;
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("@src/types");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
function CompanyCloserInformationsFields({ intl, rules }) {
    const { employeeRules, areaRules, companyUrlRules, websiteRules } = rules;
    return ((0, jsx_runtime_1.jsxs)(antd_1.Col, { xs: 24, md: 12, children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                    id: 'registration.registration_form.company_url',
                }), name: types_1.CompanyInfoEditFormField.company_url, rules: companyUrlRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input, { addonBefore: intl.formatMessage({
                        id: 'registration.registration_form.company_url_host',
                    }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                    id: 'admin.company_info_edit_form.operation_area',
                }), name: types_1.CompanyInfoEditFormField.area, rules: areaRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input, {}) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                    id: 'admin.company_info_edit_form.company_web_page',
                }), name: types_1.CompanyInfoEditFormField.website, rules: websiteRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input, {}) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                    id: 'admin.company_info_edit_form.number_of_employee',
                }), name: types_1.CompanyInfoEditFormField.employees, rules: employeeRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input, {}) })] }));
}
